import React from 'react'

export const SsoCard = ({ children }) => (
  <div className="card">
    <div className="card-body login-body">
      {children}
    </div>
  </div>
)
